<template>
  <el-dialog class="demand_model_dialog" top="5vh" center title="分布图展示" width="95%" :before-close="handleClose"
             :visible.sync="dialogVisible" :close-on-click-modal="false">
  <div class="devOps_reporterSpace_statistics" v-loading="loading">
    <div class="show-box">
      <!--        <div v-for="(item,index) in color">
                <div :style="{width:'20px',height:'20px',background:item}">&nbsp;&nbsp;&nbsp;&nbsp;{{item}}</div>
              </div>-->
      <div class="show-color">
        <span style="background: limegreen; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>已完成
        <span style="background: lightskyblue; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>进行中
        <span style="background: yellow; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>待开始
        <span style="background: lightgray; padding: 0px; ">&nbsp;&nbsp;&nbsp;&nbsp;</span>非工作日
        <span style="background: white; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>空余
        <span style="background: red; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>逾期
        <span style="background: lightpink; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>逾期风险
        <!--
        <span style="background: green; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>已完成
        <span style="background: cornflowerblue; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>进行中
        <span style="background: yellowgreen; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>待开始
        <span style="background: gray; padding: 0px; ">&nbsp;&nbsp;&nbsp;&nbsp;</span>非工作日
        <span style="background: white; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>空余
        <span style="background: red; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>逾期
        <span style="background: lightpink; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>逾期风险-->
      </div>
    </div>
  <div class="gatt-view" style="margin: 10px;">
    <gatt-view
        ref="gattView0"
        :uuId="new Date().getTime()"
        @handleCommand="handleCommand"
    ></gatt-view>
    <div class="block devOpsSpace_page">
      <span class="demonstration">当前页{{ currentPageLength || 0 }}条</span>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="count">
      </el-pagination>
    </div>
  </div>
  </div>
  </el-dialog>
</template>

<script>
/* eslint-disable camelcase */
import GattView from '@/components/GattView/index.vue'
import * as request from '@/components/data/apis/Home'
import {mapState} from "vuex";
import {getDevOpsSpaceSystemApi} from "@/server/tops/base";
import {getDevOpsSpacePerformanceDetailListApi, getDevOpsSpacePerformanceListApi} from "@/server/tops/devOps";
export default {
  name: 'GattTablePage',
  components: {
    GattView
  },
  data () {
    return {
      form: {
        team:'',
        department:'数字技术管理部',
        systemId: '',
        projectName: '',
        startDate: '',
        endDate: '',
      },
      allSystem:[],
      currentPageLength: 10,
      count: 20,
      loading: false,
      nodataShow0: true,
      nodataShow1: true,
      data0: {
        // split-pane 分割偏移百分比值
        offset: 0.2,
        // 显示的刻度(时间刻度 1:日,2周,3月,4季,5年,默认是1)
        timeMode: 1,
        // 显示星期，默认false
        dayWeek: true,
        // 最小的开始时间
        // startTime: new Date('2020/01/28').getTime(),
        startTime: new Date(2020, 0, 28).getTime(),
        // 最大的结束时间
        // endTime: new Date('2022/01/03').getTime(),
        endTime: new Date(2022, 0, 3).getTime(),
        // 表格头部的属性值(必须要设置),params设置的字段在表头设置的字段里存在才会在浮窗显示
        headData: {},
        // headData里的属性必须要和ganteData里params里的属性相对应,属性名要一样
        gattData: []
      },
      data1: {
        // split-pane 分割偏移百分比值
        offset: 0.2,
        // 显示的刻度(时间刻度 1:日,2周,3月,4季,5年,默认是1)
        timeMode: 1,
        // 最小的开始时间
        // startTime: new Date('2020/01/28').getTime(),
        startTime: new Date(2020, 0, 28).getTime(),
        // 最大的结束时间
        // endTime: new Date('2022/01/03').getTime(),
        endTime: new Date(2022, 0, 3).getTime(),
        // 表格头部的属性值(必须要设置),params设置的字段在表头设置的字段里存在才会在浮窗显示
        headData: {},
        // headData里的属性必须要和ganteData里params里的属性相对应,属性名要一样
        gattData: []
      },
      data: [],
      dataMock: {
        // split-pane 分割偏移百分比值
        offset: 0.2,
        // 显示的刻度(时间刻度 1:日,2周,3月,4季,5年,默认是1)
        timeMode: 1,
        // 最小的开始时间
        // startTime: new Date('2020/01/28').getTime(),
        startTime: new Date(2020, 0, 28).getTime(),
        // 最大的结束时间
        // endTime: new Date('2022/01/03').getTime(),
        endTime: new Date(2022, 0, 3).getTime(),
        // 表格头部的属性值(必须要设置),params设置的字段在表头设置的字段里存在才会在浮窗显示
        headData: {
        },
        // headData里的属性必须要和ganteData里params里的属性相对应,属性名要一样
        gattData: []
      },
      baseData:[{
        offset: 0.4,
        timeMode: 3,
        headData: {
          name: {
            value: '人员',
            width: '80',
            shrink: true,
            showToast: true,
            hideHead: false,
            pop:true,
          },
          department: {
            value: '职能组织',
            width: '80',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:true,
          },
          team : {
            value: '团队',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:true,
          },
          costWorkHour: {
            value: '已占用工时比',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          delayTask: {
            value: '延期任务数',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          taskCount: {
            value: '任务',
            width: '120',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          demandCount: {
            value: '需求',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          projectSystemCount: {
            value: '项目体系',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          projectCount: {
            value: '项目',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          planFinishDate: {
            value: '计划完成时间',
            width: '120',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          finishTaskCount: {
            value: '任务状态',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          submitWorkHour: {
            value: '已提交',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          totalWorkhHour: {
            value: '工时',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          processRate: {
            value: '进度',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          }
        },
        ganttData:[],
      }],
      topTimes:[],
      pickerOptions_startTime: {
        disabledDate: (time) => {
          return this.disabledDate(time)
        }
      },
      pickerOptions_endTime: {
        disabledDate: (time) => {
          return this.disabledDate(time)
        }
      },
    }
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
        }
    ),
  },
  props:{
    back: {
      type: String,
    default: '',
    },
    searchForm: {
      type: Object,
      default: {},
    },
    startDate:{
      type: String,
      default: '',
    },
    endDate:{
      type: String,
      default: '',
    },
    pageNum:{
      type: String,
      default: '',
    },
    pagecSize:{
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
    default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
    default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
    default: function () {
        return () => { }
      }
    },
  },
  async created() {
    await this.getSystem();
  },
  mounted () {
    let nowday = new Date().getDay();
    let day = nowday || 7;
    let start_date = new Date(this.$moment(new Date()).format("YYYY-MM-DD")).getTime() - 60 * 60 * 24 * 1000 * (day - 1);
    let end_date = start_date + 60 * 60 * 24 * 1000 * 4;
    this.form.startDate = this.formatDate(start_date);
    this.form.endDate = this.formatDate(end_date);
   /* if(this.startDate) this.form.startDate = this.startDate;
    if(this.endDate) this.form.endDate = this.endDate;*/
    if(this.searchForm) this.form = {...this.searchForm,pageNo:this.pageNum, pageSize:this.pagecSize};
    this.init()
  },
  methods: {
    searchTime(type){
      if(type === 1){
        //过去一周
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 7);
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      if(type === 2){
        //过去两周
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 7 * 2);
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      if(type === 3){
        //过去一个月
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 30);
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      if(type === 4){
        //未来一周
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime() + 60 * 60 * 24 * 1000 * 7);
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime());
      }
      if(type === 5){
        //未来两周
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime() + 60 * 60 * 24 * 1000 * 7 * 2);
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime());
      }
      if(type === 6){
        //未来一个月
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime() + 60 * 60 * 24 * 1000 * 30);
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime());
      }
      if(type === 7){
        //新增 本周
        let nowday = new Date().getDay();
        let day = nowday || 7;
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1));
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      this.getGattListFn('reset','search');
      //this.init()
    },
    // 关闭弹窗
    handleClose(step) {
      if(this.back){
        this.hideDialogVisible('project')
      }else{
        this.hideDialogVisible(step)
      }
    },
    changeTimeDate(timestamp){
      let dateObj = new Date(timestamp);
      // 提取所需的年、月、日等信息
      let year = dateObj.getFullYear();
      let month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      let day = dateObj.getDate().toString().padStart(2, '0');
       // 构造最终的日期/时间字符串
      let formattedTime = `${year}-${month}-${day}`;
      return formattedTime;
    },
    commonData(ret){
      let arr = [];
      ret.data.forEach((item)=>{
        let pColor = [];
        let isOverTime = 0;
        if(item.workHourChart){
          // topTimes = Object.keys(info.workHourChart);
          Object.keys(item.workHourChart).forEach((item2,i2) => {
            item.workHourChart[item2].map((item3,index3)=>{
              if(item3.color === 'red') isOverTime = 1;
              let username = item.user.nameZh ? item.user.nameZh: '';
              pColor.push({background:this.handleColor(item3.color),bugCount:item3.bug_count,left:25.65555 * index3,width:23,name:username, department:item.department,team:item.team});
            })
          });
          pColor.forEach((cv,ci)=>{
            pColor[ci]['left'] = 25.65555 * ci;
          })
        }
        let params = {
          name: item.user.nameZh,
          department: item.department,
          costWorkHour: item.costWorkHour + '/' + item.totalWorkhHour,
          totalWorkhHour: item.totalWorkhHour,
          delayTask: item.delayTask,
          taskCount: item.taskCount,
          demandCount: item.demandCount,
          projectSystemCount: item.projectSystemCount,
          projectCount: item.projectCount,
          planFinishDate: item.planFinishDate,
          finishTaskCount: item.finishTaskCount + '/' + item.taskCount,
          submitWorkHour: item.submitWorkHour,
          team:item.team,
          processRate:item.processRate + '%',
          pColor: pColor,
          isOverTime: isOverTime,
        };
        arr.push({id:item.user.id,level: 1, open: false, children: [],params});
      })
      const info = ret.data[0] || {};
      let topTimes = [];
      let colors = [];
      if(info.workHourChart){
       // topTimes = Object.keys(info.workHourChart);
        Object.keys(info.workHourChart).forEach((item,i) => {
          topTimes.push({date:item,left:25.65555*i,width:488});
        });

      }
      this.topTimes = topTimes;
      this.baseData = {
        offset: 0.4,
        timeMode: 3,
        headData: {
          name: {
            value: '人员',
            width: '136',
            shrink: true,
            showToast: true,
            hideHead: false,
            pop:true,
          },
         /* department: {
            value: '职能组织',
            width: '120',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:true,
          },
          team : {
            value: '团队',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:true,
          },
          costWorkHour: {
            value: '已占用工时比',
            width: '120',
            shrink: true,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          delayTask: {
            value: '延期任务数',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          taskCount: {
            value: '任务',
            width: '120',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          demandCount: {
            value: '需求',
            width: '120',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          projectSystemCount: {
            value: '项目体系',
            width: '120',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          projectCount: {
            value: '项目',
            width: '120',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          planFinishDate: {
            value: '计划完成时间',
            width: '120',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          finishTaskCount: {
            value: '任务状态',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          submitWorkHour: {
            value: '已提交',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          totalWorkhHour: {
            value: '工时',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          },
          processRate: {
            value: '进度',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop:false,
          }*/
        },
        ganttData:arr,
        topTimes:topTimes,
        showColor:colors,
      };
    },
    async getSystem() {
      let arr = {};
      await getDevOpsSpaceSystemApi().then((res) => {
        res.data.forEach((item)=>{
          arr[item.id] = item.nameZh;
        });
      });
     this.allSystem = arr;
    },
    handleColor(color){
      if(color === 'blank'){
        //空余
        return 'white';
      }else if(color === 'green'){
        //已完成
        return 'limegreen';

      }else if(color === 'blue'){
        //进行中
        return 'lightskyblue';

      }else if(color === 'red'){
        //逾期
        return 'red';
      }else if(color === 'yellow'){
        //待开始
        return 'yellow';
      }else if(color === 'pink'){
         //逾期风险
        return 'lightpink';
      }else if(color === 'gray'){
        //非工作日
        return 'lightgray';
      }else{
         return 'white';
      }
    },
    init () {
      this.getGattListFn()
      // this.$refs.gattView.init({
      //   timeMode: this.data.timeMode,
      //   offset: this.data.offset,
      //   startTime: this.data.startTime,
      //   endTime: this.data.endTime,
      //   headData: this.data.headData,
      //   gattData: this.data.gattData
      // })
    },
    // 分页
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.form.pageNo = 1;
      this.form.pageSize = val;
      this.getGattListFn();
    },
    // 分页事件
    handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getGattListFn();
    },
    async getGattListFn(type, key) {
      if((this.form.startDate && !this.form.endDate) || (!this.form.startDate && this.form.endDate)){
        this.$notify({
          message: "请选择日期",
          type: "error",
        })
        return false;
      }
      if(this.form.startDate && this.form.endDate){
        if(this.form.startDate > this.form.endDate){
          this.$notify({
            message: "结束日期必须大于开始日期",
            type: "error",
          })
          return false;
        }
      }
      const d = [{
        offset: 0.4,
        timeMode: 3,
        headData: {
          name: {
            value: '人员',
            width: '80',
            shrink: true,
            showToast: true,
            hideHead: false,
            pop: true,
          },
          department: {
            value: '职能组织',
            width: '80',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: true,
          },
          team: {
            value: '团队',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: true,
          },
          costWorkHour: {
            value: '已占用工时比',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: false,
          },
          delayTask: {
            value: '延期任务数',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: false,
          },
          taskCount: {
            value: '任务',
            width: '120',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: false,
          },
          demandCount: {
            value: '需求',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: false,
          },
          projectSystemCount: {
            value: '项目体系',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: false,
          },
          projectCount: {
            value: '项目',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: false,
          },
          planFinishDate: {
            value: '计划完成时间',
            width: '120',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: false,
          },
          finishTaskCount: {
            value: '任务状态',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: false,
          },
          submitWorkHour: {
            value: '已提交',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: false,
          },
          totalWorkhHour: {
            value: '工时',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: false,
          },
          processRate: {
            value: '进度',
            width: '100',
            shrink: false,
            showToast: true,
            hideHead: false,
            pop: false,
          }
        },
        ganttData: [{
          id: '5266261',
          level: 1,
          open: true,
          children: [{
            id: '5315465',
            level: 2,
            params: {
              name: '',
              department: '',
              costWorkHour: '111',
              totalWorkhHour: '222',
              delayTask: '3333',
              taskCount: '44444',
              demandCount: '5555',
              projectSystemCount: '6666',
              projectCount: '7777',
              planFinishDate: '8888',
              finishTaskCount: '99999',
              submitWorkHour: '101010',
              team: '',
              processRate: '121212',
            },
            perBgColor: '#13587E',
            bgcColor: '#13587E'
          }, {
            id: '5308158',
            level: 2,
            params: {
              name: '',
              department: '',
              costWorkHour: '111',
              totalWorkhHour: '222',
              delayTask: '3333',
              taskCount: '44444',
              demandCount: '5555',
              projectSystemCount: '6666',
              projectCount: '7777',
              planFinishDate: '8888',
              finishTaskCount: '99999',
              submitWorkHour: '101010',
              team: '',
              processRate: '121212',
            },
            perBgColor: '#3EB88D',
            bgcColor: '#3EB88D'
          }, {
            id: '5316097',
            level: 2,
            params: {
              name: '',
              department: '',
              costWorkHour: '111',
              totalWorkhHour: '222',
              delayTask: '3333',
              taskCount: '44444',
              demandCount: '5555',
              projectSystemCount: '6666',
              projectCount: '7777',
              planFinishDate: '8888',
              finishTaskCount: '99999',
              submitWorkHour: '101010',
              team: '',
              processRate: '121212',
            },
          }, {
            id: '5313750',
            level: 2,
            params: {
              name: '',
              department: '',
              costWorkHour: '111',
              totalWorkhHour: '222',
              delayTask: '3333',
              taskCount: '44444',
              demandCount: '5555',
              projectSystemCount: '6666',
              projectCount: '7777',
              planFinishDate: '8888',
              finishTaskCount: '99999',
              submitWorkHour: '101010',
              team: '',
              processRate: '121212',
            }
          }],
          params: {
            name: 'xxxxx',
            department: 'qqqq',
            costWorkHour: '111',
            totalWorkhHour: '222',
            delayTask: '3333',
            taskCount: '44444',
            demandCount: '5555',
            projectSystemCount: '6666',
            projectCount: '7777',
            planFinishDate: '8888',
            finishTaskCount: '99999',
            submitWorkHour: '101010',
            team: 'wwww',
            processRate: '121212',
          }
        }]
      }]
      if (type === 'reset') {
        this.pageNo = 1;
        this.currentPage = 1;
      }
      try {
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        if(this.form.pageNo && this.form.pageSize){
          this.currentPage = this.form.pageNo;
          params.pageNo = this.form.pageNo;
          params.pageSize = this.form.pageSize
        }else{
          params.pageNo = this.currentPage
          params.pageSize = this.pageSize
        }

        this.loading = true;
        const ret = await getDevOpsSpacePerformanceListApi(params);
        this.baseData.ganttData = this.commonData(ret);
        this.setDataInit(this.baseData)
        this.tableData = ret.data;
        this.cacheTableData = ret.data;
        this.currentPageLength = ret.data.length;
        this.count = ret.count;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading = false;
      }
      /*if (d.length) {
        this.data = d
        this.setDataInit(d)
      } else {
        this.nodataShow0 = true
        this.nodataShow1 = true
      }*/
    },
    setDataInit (d) {
        //this['nodataShow' + index] = false
        /*this['data0'].timeMode = item.timeMode
        this['data' + index].offset = item.offset
        this['data' + index].startTime = item.startTime
        this['data' + index].endTime = item.endTime*/
        this['data0'].headData = d.headData
        this['data0'].gattData = d.ganttData
        this['data0'].topTimes = d.topTimes
        this['data0'].showColor = d.showColor

        /*this['data' + index].gattData.length &&*/
        this.$refs['gattView0'] &&
        this.$refs['gattView0'].init({
          timeMode: this['data0'].timeMode,
          offset: this['data0'].offset,
          headData: this['data0'].headData,
          gattData: this['data0'].gattData,
          topTimes: this['data0'].topTimes,
          showColor: this['data0'].showColor,
        })

    },
    formatDate(time) {
      let date = new Date(time);
      let myyear = date.getFullYear();
      let mymonth = date.getMonth() + 1;
      let myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = '0' + mymonth;
      }
      if (myweekday < 10) {
        myweekday = '0' + myweekday;
      }
      return (myyear + '-' + mymonth + '-' + myweekday);
    },
    handleClick (d) {
      // console.log(d)
      // debugger
    },
    change (d) {
      // console.log(d)
      // debugger
    },
    disabledDate(time) {
      const nowTime = Date.now() - 365 * 60 * 60 * 24 * 1000;
      return time.getTime() <= nowTime;
    },
    handleCommand (tdData) {
      console.log(tdData);
      let uid = tdData.id;
      let user_name = tdData.params.name;
      let user_department = tdData.params.department;
      let user_team = tdData.params.team;

      this.loading = true;
      let params = {...this.form,user_set:uid};
      getDevOpsSpacePerformanceDetailListApi(params).then((ret)=>{
        const result = ret.data;
        if(result){
          result.forEach((r,k)=>{
            let arr = [];
            if(ret.workHourChart){
              const workHourChart = ret.workHourChart;
              Object.keys(workHourChart).forEach((item2,i2) => {
                workHourChart[item2].map((item3,index3)=>{
                  arr.push(item3);
                })
              });
            }
            let newColor = [];
            for(let j=0;j<arr.length;j++){
              if(arr[j]['task_id'] && (r.task_type + '_' + r.id) != arr[j]['task_id']){
                  newColor.push({background: this.handleColor('blank'),bugCount: 0,left:25.65555 * j,width:23,name:user_name, department:user_department,team:user_team,taskName:r.taskName});
              }else{
                newColor.push({background:this.handleColor(arr[j]['color']),bugCount: arr[j]['bug_count'],left:25.65555 * j,width:23,name:user_name, department:user_department,team:user_team,taskName:r.taskName});
              }
            }
            result[k]['newColor'] = newColor;
          })
        }
        let children = [];
        result.forEach((chv,chk)=>{
          let param = {
            name: '',
            department: '',
            team: '',
            costWorkHour: chv.costWorkHour + '/' + chv.totalWorkhHour,
            totalWorkhHour: chv.estimate_work_hour,
            delayTask: chv.delayTask,
            taskCount: '【'+ chv.taskId+'】'+chv.taskName,
            demandCount: '【'+ chv.demandId+'】'+chv.demandName,
            projectSystemCount: chv.projectSystem,
            projectCount: '【'+ chv.projectId+'】'+chv.projectName,
            planFinishDate: chv.planFinishDate,
            finishTaskCount: chv.status_desc,
            submitWorkHour: chv.submitWorkHour,
            processRate: chv.task_process,
            pColor: chv.newColor,
            taskId:chv.taskId,
            demandId:chv.demandId,
            projectId: chv.projectId,
          };
          children.push({ id: chv.taskId, level: 2,params:param});
        })

        //console.log(this.baseData.ganttData)
          for (var i of this.baseData.ganttData) {
            i.children = children;
            console.log(i);
           if (i.id ===  uid) {
              i.open = true;

            }else{
             i.open = false;
           }
          }
        this.loading = false;

        console.log(123456789);
        console.log(children);
      })
     /* if (this.data.length) {
        this.data.forEach(item => {
          item.timeMode = ~~command
        })
        this.setDataInit(this.data)
      }*/
    }
  }
}
</script>

<style>
.gatt-wrap {
  width: 100%;
  height: 69vh;
  border: 1px solid #ccc;
  overflow: hidden;
  box-sizing: border-box;
}
.gatt-wrap .gatt-left,
.gatt-wrap .gatt-right {
  overflow: auto;
  height: 100%;
  box-sizing: border-box;
}
.gatt-wrap .tool-tip {
  position: fixed;
  right: 0;
  top: 60px;
  z-index: 99;
  font-weight: 400;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.gatt-wrap .tool-tip .today {
  display: inline-block;
  height: 30px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  line-height: 30px;
  padding: 0 15px;
  background-color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: #303030;
  border-radius: 3px;
  box-shadow: 0 3px 12px 0 rgba(48,48,48,0.05), 0 3px 6px 0 rgba(48,48,48,0.1);
  margin-right: 20px;
}
.gatt-wrap .tool-tip .today height,
.gatt-wrap .tool-tip .today:hover {
  color: #409eff;
}
.gatt-wrap .tool-tip .tool-tip-drop .el-dropdown-link {
  height: 30px;
  display: inline-block;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  line-height: 30px;
  padding: 0 15px;
  background-color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: #303030;
  border-radius: 3px;
  box-shadow: 0 3px 12px 0 rgba(48,48,48,0.05), 0 3px 6px 0 rgba(48,48,48,0.1);
  margin-right: 20px;
}
.gatt-wrap .tool-tip .tool-tip-drop .el-dropdown-link:hover {
  color: #409eff;
}
.time-box{
  margin-bottom: 15px;
  margin-left: 15px;
}
.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 5px 25px 30px;
}
</style>
